var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      rowKey: "id",
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "isPriority",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.priorityFun(record);
            }
          }
        })];
      }
    }, {
      key: "name",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.moveFun(record, 1);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("上移")))]), _c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.moveFun(record, 2);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下移")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };